declare namespace $ {

	type $mol_view__sub_shm_hitalama_map_widget_float_table_form_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_form_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_form_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_form_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_form_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_form_field__name_shm_hitalama_map_widget_float_table_form_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['field_name'] >
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__bid_shm_hitalama_map_widget_float_table_form_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['field_bid'] >
		,
		ReturnType< $mol_form_field['bid'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_widget_float_table_form_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['Field_content'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $shm_hitalama_form_submit__title_shm_hitalama_map_widget_float_table_form_9 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_form_submit['title'] >
	>
	type $shm_hitalama_form_submit__click_shm_hitalama_map_widget_float_table_form_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['submit'] >
		,
		ReturnType< $shm_hitalama_form_submit['click'] >
	>
	type $shm_hitalama_form_submit__enabled_shm_hitalama_map_widget_float_table_form_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['submit_allowed'] >
		,
		ReturnType< $shm_hitalama_form_submit['enabled'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_form_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_form_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['clear_ask'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_major__title_shm_hitalama_map_widget_float_table_form_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_map_widget_float_table_form_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['clear_confirm'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_form_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_form_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['clear_cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_form_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_form_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_status__message_shm_hitalama_map_widget_float_table_form_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['submit_result'] >
		,
		ReturnType< $mol_status['message'] >
	>
	type $mol_status__style_shm_hitalama_map_widget_float_table_form_21 = $mol_type_enforce<
		({ 
			'color': string,
		})  & ReturnType< $mol_status['style'] >
		,
		ReturnType< $mol_status['style'] >
	>
	type $mol_form__form_fields_shm_hitalama_map_widget_float_table_form_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['form_fields'] >
		,
		ReturnType< $mol_form['form_fields'] >
	>
	type $mol_form__buttons_shm_hitalama_map_widget_float_table_form_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['buttons'] >
		,
		ReturnType< $mol_form['buttons'] >
	>
	type $mol_string__value_shm_hitalama_map_widget_float_table_form_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['field_value'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_textarea__value_shm_hitalama_map_widget_float_table_form_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['field_value'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $shm_date_view__value_shm_hitalama_map_widget_float_table_form_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['field_value'] >
		,
		ReturnType< $shm_date_view['value'] >
	>
	type $mol_number__value_shm_hitalama_map_widget_float_table_form_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['field_number'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type __shm_hitalama_map_widget_float_table_form_28 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_widget_float_table_form['period_str'] >[0]
		,
		Parameters< $shm_hitalama_map_widget_float_table_form['Period'] >[0]
	>
	type $shm_period__period_shm_hitalama_map_widget_float_table_form_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['field_value'] >
		,
		ReturnType< $shm_period['period'] >
	>
	type $shm_hitalama_file_attach__files_shm_hitalama_map_widget_float_table_form_30 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['field_files'] >
		,
		ReturnType< $shm_hitalama_file_attach['files'] >
	>
	type $shm_hitalama_file_attach__value_shm_hitalama_map_widget_float_table_form_31 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['field_value'] >
		,
		ReturnType< $shm_hitalama_file_attach['value'] >
	>
	type $shm_hitalama_file_attach_pb__value_shm_hitalama_map_widget_float_table_form_32 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['field_value'] >
		,
		ReturnType< $shm_hitalama_file_attach_pb['value'] >
	>
	type $shm_hitalama_file_attach_pb__map_id_shm_hitalama_map_widget_float_table_form_33 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['pb_map_id'] >
		,
		ReturnType< $shm_hitalama_file_attach_pb['map_id'] >
	>
	type $shm_hitalama_file_attach_pb__widget_id_shm_hitalama_map_widget_float_table_form_34 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['pb_widget_id'] >
		,
		ReturnType< $shm_hitalama_file_attach_pb['widget_id'] >
	>
	type $shm_hitalama_file_attach_pb__field_name_shm_hitalama_map_widget_float_table_form_35 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['field_name'] >
		,
		ReturnType< $shm_hitalama_file_attach_pb['field_name'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_atom__value_shm_hitalama_map_widget_float_table_form_36 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['field_value'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_atom['value'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_atom__dictionary_shm_hitalama_map_widget_float_table_form_37 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['field_link_options'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_atom['dictionary'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_atom__active_shm_hitalama_map_widget_float_table_form_38 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['field_relation_active'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_atom['active'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_atom__open_shm_hitalama_map_widget_float_table_form_39 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['field_relation_open'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_atom['open'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_atom__create_shm_hitalama_map_widget_float_table_form_40 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['field_relation_create'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_atom['create'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_list__value_shm_hitalama_map_widget_float_table_form_41 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['field_list_value'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_list['value'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_list__dictionary_shm_hitalama_map_widget_float_table_form_42 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['field_link_options'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_list['dictionary'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_list__active_shm_hitalama_map_widget_float_table_form_43 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['field_relation_active'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_list['active'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_list__open_shm_hitalama_map_widget_float_table_form_44 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['field_relation_open'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_list['open'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_list__create_shm_hitalama_map_widget_float_table_form_45 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['field_relation_create'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_list['create'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_list__create_current_shm_hitalama_map_widget_float_table_form_46 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['field_relation_create_current'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_list['create_current'] >
	>
	type $mol_select__value_shm_hitalama_map_widget_float_table_form_47 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['field_value'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_map_widget_float_table_form_48 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_form['field_select_dictionary'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__Filter_shm_hitalama_map_widget_float_table_form_49 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	export class $shm_hitalama_map_widget_float_table_form extends $mol_view {
		Form_title_text( ): $mol_view
		Form_title( ): $mol_view
		close( next?: any ): any
		Close( ): $mol_button_minor
		Form_head( ): $mol_view
		field_name( id: any): string
		field_bid( id: any): string
		Field_content( id: any): $mol_view
		Field( id: any): $mol_form_field
		form_fields( ): readonly(any)[]
		submit_allowed( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_table_form['Form'] >['submit_allowed'] >
		submit( next?: any ): any
		Publish( ): $shm_hitalama_form_submit
		clear_ask( next?: any ): any
		Clear( ): $mol_button_minor
		clear_button_visible( ): readonly(any)[]
		clear_confirm( next?: any ): any
		Clear_confirm( ): $mol_button_major
		clear_cancel( next?: any ): any
		Clear_cancel( ): $mol_button_minor
		clear_confirm_visible( ): readonly(any)[]
		Clear_actions( ): $mol_view
		Actions( ): $mol_view
		submit_result( next?: string ): string
		Submit_result( ): $mol_status
		submit_result_visible( ): readonly(any)[]
		buttons( ): readonly(any)[]
		Form( ): $mol_form
		field_value( id: any, next?: any ): any
		String( id: any): $mol_string
		Textarea( id: any): $mol_textarea
		Date( id: any): $shm_date_view
		field_number( id: any, next?: number ): number
		Number( id: any): $mol_number
		period_str( id: any): ReturnType< ReturnType< $shm_hitalama_map_widget_float_table_form['Period'] >['period_str'] >
		Period( id: any): $shm_period
		field_files( id: any, next?: readonly(any)[] ): readonly(any)[]
		File( id: any): $shm_hitalama_file_attach
		pb_map_id( ): string
		pb_widget_id( ): string
		File_pb( id: any): $shm_hitalama_file_attach_pb
		field_link_options( id: any): Record<string, any>
		field_relation_active( id: any): string
		field_relation_open( id: any, next?: string ): string
		field_relation_create( id: any, next?: any ): any
		Atom_link( id: any): $shm_hitalama_map_widget_float_table_relation_atom
		field_list_value( id: any, next?: readonly(string)[] ): readonly(string)[]
		field_relation_create_current( id: any): boolean
		List_link( id: any): $shm_hitalama_map_widget_float_table_relation_list
		field_select_dictionary( id: any): Record<string, any>
		Select( id: any): $mol_select
		table( ): $shm_hitalama_map_widget_float_table
		row_index( ): number
		title( ): string
		sub( ): readonly(any)[]
		clear_asked( next?: boolean ): boolean
		Content_by_type( id: any): ({ 
			'any': ReturnType< $shm_hitalama_map_widget_float_table_form['String'] >,
			'string': ReturnType< $shm_hitalama_map_widget_float_table_form['String'] >,
			'textarea': ReturnType< $shm_hitalama_map_widget_float_table_form['Textarea'] >,
			'date': ReturnType< $shm_hitalama_map_widget_float_table_form['Date'] >,
			'number': ReturnType< $shm_hitalama_map_widget_float_table_form['Number'] >,
			'period': ReturnType< $shm_hitalama_map_widget_float_table_form['Period'] >,
			'file': ReturnType< $shm_hitalama_map_widget_float_table_form['File'] >,
			'file_pb': ReturnType< $shm_hitalama_map_widget_float_table_form['File_pb'] >,
			'atom_link': ReturnType< $shm_hitalama_map_widget_float_table_form['Atom_link'] >,
			'list_link': ReturnType< $shm_hitalama_map_widget_float_table_form['List_link'] >,
			'select': ReturnType< $shm_hitalama_map_widget_float_table_form['Select'] >,
		}) 
	}
	
	export class $shm_hitalama_map_widget_float_table_col_name extends $mol_string {
		commit( next?: any ): any
		submit( next?: ReturnType< $shm_hitalama_map_widget_float_table_col_name['commit'] > ): ReturnType< $shm_hitalama_map_widget_float_table_col_name['commit'] >
		event( ): ({ 
			blur( next?: ReturnType< $shm_hitalama_map_widget_float_table_col_name['commit'] > ): ReturnType< $shm_hitalama_map_widget_float_table_col_name['commit'] >,
		})  & ReturnType< $mol_string['event'] >
	}
	
	export class $shm_hitalama_map_widget_float_table_relation_form extends $shm_hitalama_map_widget_float_table_form {
		table_relation( ): any
		page_index( ): number
	}
	
	export class $shm_hitalama_map_widget_float_table_link_list extends $shm_check_list {
		table_relation( ): any
		cell_id( ): any
	}
	
	type $mol_string_button__value_shm_hitalama_map_widget_float_table_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['title'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $shm_hitalama_map_widget_float_table_form__table_shm_hitalama_map_widget_float_table_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_self'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_form['table'] >
	>
	type $shm_hitalama_map_widget_float_table_form__row_index_shm_hitalama_map_widget_float_table_3 = $mol_type_enforce<
		number
		,
		ReturnType< $shm_hitalama_map_widget_float_table_form['row_index'] >
	>
	type $shm_hitalama_map_widget_float_table_form__title_shm_hitalama_map_widget_float_table_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['edit_form_title'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_form['title'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_float__dom_name_shm_hitalama_map_widget_float_table_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_float['dom_name'] >
	>
	type $mol_float__sub_shm_hitalama_map_widget_float_table_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['col_head_content'] >
		,
		ReturnType< $mol_float['sub'] >
	>
	type $mol_float__style_shm_hitalama_map_widget_float_table_8 = $mol_type_enforce<
		({ 
			'padding': ReturnType< $shm_hitalama_map_widget_float_table['col_head_padding'] >,
			'width': ReturnType< $shm_hitalama_map_widget_float_table['col_head_width'] >,
			'maxWidth': string,
		})  & ReturnType< $mol_float['style'] >
		,
		ReturnType< $mol_float['style'] >
	>
	type __shm_hitalama_map_widget_float_table_9 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_widget_float_table['cell_content_text'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_widget_float_table['Table'] >['cell_content_text'] >[0]
	>
	type $mol_grid_row__cells_shm_hitalama_map_widget_float_table_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['grid_cells'] >
		,
		ReturnType< $mol_grid_row['cells'] >
	>
	type $mol_grid_row__attr_shm_hitalama_map_widget_float_table_11 = $mol_type_enforce<
		({ 
			'selected': ReturnType< $shm_hitalama_map_widget_float_table['row_selected'] >,
		})  & ReturnType< $mol_grid_row['attr'] >
		,
		ReturnType< $mol_grid_row['attr'] >
	>
	type $shm_hitalama_map_widget_float_table_grid__records_shm_hitalama_map_widget_float_table_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['rows'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_grid['records'] >
	>
	type $shm_hitalama_map_widget_float_table_grid__scroll_top_shm_hitalama_map_widget_float_table_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_scroll_top'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_grid['scroll_top'] >
	>
	type $shm_hitalama_map_widget_float_table_grid__viewport_height_shm_hitalama_map_widget_float_table_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_viewport_height'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_grid['viewport_height'] >
	>
	type $shm_hitalama_map_widget_float_table_grid__col_ids_shm_hitalama_map_widget_float_table_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['col_ids'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_grid['col_ids'] >
	>
	type $shm_hitalama_map_widget_float_table_grid__col_head_content_shm_hitalama_map_widget_float_table_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['col_head_content'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_grid['col_head_content'] >
	>
	type $shm_hitalama_map_widget_float_table_grid__Col_head_shm_hitalama_map_widget_float_table_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['Col_head'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_grid['Col_head'] >
	>
	type $shm_hitalama_map_widget_float_table_grid__Cell_shm_hitalama_map_widget_float_table_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['Cell'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_grid['Cell'] >
	>
	type $shm_hitalama_map_widget_float_table_grid__row_ids_shm_hitalama_map_widget_float_table_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_row_ids'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_grid['row_ids'] >
	>
	type $shm_hitalama_map_widget_float_table_grid__header_height_shm_hitalama_map_widget_float_table_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_header_height'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_grid['header_height'] >
	>
	type $shm_hitalama_map_widget_float_table_grid__render_visible_only_shm_hitalama_map_widget_float_table_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_virtual'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_grid['render_visible_only'] >
	>
	type $shm_hitalama_map_widget_float_table_grid__Row_shm_hitalama_map_widget_float_table_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['Grid_row'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_grid['Row'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_scroll__sub_shm_hitalama_map_widget_float_table_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_scroll['sub'] >
	>
	type $mol_search__hint_shm_hitalama_map_widget_float_table_25 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_search['hint'] >
	>
	type $mol_search__query_shm_hitalama_map_widget_float_table_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['search'] >
		,
		ReturnType< $mol_search['query'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_28 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['reset_filters'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_32 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_widget_float_table_33 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_34 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_table_35 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__attr_shm_hitalama_map_widget_float_table_36 = $mol_type_enforce<
		({ 
			'active': ReturnType< $shm_hitalama_map_widget_float_table['add_active'] >,
			'aria-pressed': ReturnType< $shm_hitalama_map_widget_float_table['add_active'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $shm_hitalama_map_widget_float_table_command__title_shm_hitalama_map_widget_float_table_37 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_map_widget_float_table_command['title'] >
	>
	type $shm_hitalama_map_widget_float_table_command__hint_shm_hitalama_map_widget_float_table_38 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_map_widget_float_table_command['hint'] >
	>
	type $shm_hitalama_map_widget_float_table_command__click_shm_hitalama_map_widget_float_table_39 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['add_column'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_command['click'] >
	>
	type $shm_hitalama_map_widget_float_table_command__sub_shm_hitalama_map_widget_float_table_40 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_map_widget_float_table_command['sub'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_41 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_widget_float_table_42 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_43 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_edit_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_table_44 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__attr_shm_hitalama_map_widget_float_table_45 = $mol_type_enforce<
		({ 
			'active': ReturnType< $shm_hitalama_map_widget_float_table['table_edit_active'] >,
			'aria-pressed': ReturnType< $shm_hitalama_map_widget_float_table['table_edit_active'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_46 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_widget_float_table_47 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_48 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['search_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_table_49 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__attr_shm_hitalama_map_widget_float_table_50 = $mol_type_enforce<
		({ 
			'active': ReturnType< $shm_hitalama_map_widget_float_table['search_active'] >,
			'aria-pressed': ReturnType< $shm_hitalama_map_widget_float_table['search_opened'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_51 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paginator__value_shm_hitalama_map_widget_float_table_52 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['page_index'] >
		,
		ReturnType< $mol_paginator['value'] >
	>
	type $mol_paginator__Value_shm_hitalama_map_widget_float_table_53 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['Pagination_value'] >
		,
		ReturnType< $mol_paginator['Value'] >
	>
	type $mol_paginator__backward_hint_shm_hitalama_map_widget_float_table_54 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paginator['backward_hint'] >
	>
	type $mol_paginator__forward_hint_shm_hitalama_map_widget_float_table_55 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paginator['forward_hint'] >
	>
	type $mol_select__Filter_shm_hitalama_map_widget_float_table_56 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_select__value_shm_hitalama_map_widget_float_table_57 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['page_size_selected'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__options_shm_hitalama_map_widget_float_table_58 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__dictionary_shm_hitalama_map_widget_float_table_59 = $mol_type_enforce<
		({ 
			'0': string,
		}) 
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_table_60 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_table_61 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['Page_size'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_62 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_63 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_64 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_65 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_66 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_67 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_edit_close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_68 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_textarea__value_shm_hitalama_map_widget_float_table_69 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_schema'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__hint_shm_hitalama_map_widget_float_table_70 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__spellcheck_shm_hitalama_map_widget_float_table_71 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_textarea['spellcheck'] >
	>
	type $mol_textarea__enabled_shm_hitalama_map_widget_float_table_72 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_schema_enabled'] >
		,
		ReturnType< $mol_textarea['enabled'] >
	>
	type $mol_form_field__name_shm_hitalama_map_widget_float_table_73 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_widget_float_table_74 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['Table_schema'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_number__value_shm_hitalama_map_widget_float_table_75 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_rows_limit'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__hint_shm_hitalama_map_widget_float_table_76 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_number['hint'] >
	>
	type $mol_number__precision_shm_hitalama_map_widget_float_table_77 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_number['precision'] >
	>
	type $mol_number__precision_change_shm_hitalama_map_widget_float_table_78 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_number['precision_change'] >
	>
	type $mol_form_field__name_shm_hitalama_map_widget_float_table_79 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_widget_float_table_80 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['Table_rows_limit'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_float_table_81 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_table_82 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['delete_enabled'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_list__rows_shm_hitalama_map_widget_float_table_83 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['col_width_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_form_field__name_shm_hitalama_map_widget_float_table_84 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_widget_float_table_85 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['Table_widths'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $shm_check_list__options_shm_hitalama_map_widget_float_table_86 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['column_visibility_options'] >
		,
		ReturnType< $shm_check_list['options'] >
	>
	type $shm_check_list__value_shm_hitalama_map_widget_float_table_87 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['columns_visible'] >
		,
		ReturnType< $shm_check_list['value'] >
	>
	type $mol_form_field__name_shm_hitalama_map_widget_float_table_88 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_widget_float_table_89 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['Table_visibility'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_list__rows_shm_hitalama_map_widget_float_table_90 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_editor_fields'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_scroll__sub_shm_hitalama_map_widget_float_table_91 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_scroll['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_92 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_map_widget_float_table_form__table_shm_hitalama_map_widget_float_table_93 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_self'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_form['table'] >
	>
	type $shm_hitalama_map_widget_float_table_form__row_index_shm_hitalama_map_widget_float_table_94 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['edit_row_index'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_form['row_index'] >
	>
	type $shm_hitalama_map_widget_float_table_form__title_shm_hitalama_map_widget_float_table_95 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['edit_form_title'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_form['title'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_96 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_shm_hitalama_map_widget_float_table_97 = $mol_type_enforce<
		({ 
			'height': string,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_98 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['workspace_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_form__table_shm_hitalama_map_widget_float_table_99 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_self'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_form['table'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_form__table_relation_shm_hitalama_map_widget_float_table_100 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_self'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_form['table_relation'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_form__page_index_shm_hitalama_map_widget_float_table_101 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_relation_page_index'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_form['page_index'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_102 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_button_copy__button_sub_shm_hitalama_map_widget_float_table_103 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_button_copy['button_sub'] >
	>
	type $shm_button_copy__text_shm_hitalama_map_widget_float_table_104 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['cell_content_text_str'] >
		,
		ReturnType< $shm_button_copy['text'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_105 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_106 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_atom_label'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_107 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_atom_open'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__attr_shm_hitalama_map_widget_float_table_108 = $mol_type_enforce<
		({ 
			'selected': ReturnType< $shm_hitalama_map_widget_float_table['table_atom_current'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_select__value_shm_hitalama_map_widget_float_table_109 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_atom_value'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_map_widget_float_table_110 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_relation_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__trigger_content_shm_hitalama_map_widget_float_table_111 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_select['trigger_content'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_112 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_113 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_relation_create'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_table_114 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_115 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_map_widget_float_table_link_list__table_relation_shm_hitalama_map_widget_float_table_116 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_self'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_link_list['table_relation'] >
	>
	type $shm_hitalama_map_widget_float_table_link_list__cell_id_shm_hitalama_map_widget_float_table_117 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_list_cell_id'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_link_list['cell_id'] >
	>
	type $shm_hitalama_map_widget_float_table_link_list__options_shm_hitalama_map_widget_float_table_118 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_list_option_ids'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_link_list['options'] >
	>
	type $shm_hitalama_map_widget_float_table_link_list__value_shm_hitalama_map_widget_float_table_119 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_list_picker_value'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_link_list['value'] >
	>
	type $mol_pick__trigger_content_shm_hitalama_map_widget_float_table_120 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_hitalama_map_widget_float_table_121 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_122 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_123 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_relation_create'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_table_124 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__attr_shm_hitalama_map_widget_float_table_125 = $mol_type_enforce<
		({ 
			'selected': ReturnType< $shm_hitalama_map_widget_float_table['table_relation_create_current'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_126 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_select__value_shm_hitalama_map_widget_float_table_127 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_select_value'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_map_widget_float_table_128 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_select_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__Filter_shm_hitalama_map_widget_float_table_129 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_button_download__uri_shm_hitalama_map_widget_float_table_130 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['cell_file_uri'] >
		,
		ReturnType< $mol_button_download['uri'] >
	>
	type $mol_button_download__file_name_shm_hitalama_map_widget_float_table_131 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['cell_file_name'] >
		,
		ReturnType< $mol_button_download['file_name'] >
	>
	type $mol_button_download__sub_shm_hitalama_map_widget_float_table_132 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_download['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_133 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__uri_shm_hitalama_map_widget_float_table_134 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['cell_file_pb_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__target_shm_hitalama_map_widget_float_table_135 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['target'] >
	>
	type $mol_link__sub_shm_hitalama_map_widget_float_table_136 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_137 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_table_138 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['cell_checked'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_139 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_140 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['cell_delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_141 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_142 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['cell_edit'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__attr_shm_hitalama_map_widget_float_table_143 = $mol_type_enforce<
		({ 
			'active': ReturnType< $shm_hitalama_map_widget_float_table['action_edit_active'] >,
			'aria-pressed': ReturnType< $shm_hitalama_map_widget_float_table['action_edit_active'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_144 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['custom_cell_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_145 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_146 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_shm_hitalama_map_widget_float_table_147 = $mol_type_enforce<
		({ 
			'title': ReturnType< $shm_hitalama_map_widget_float_table['col_indicators_hint'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_table_148 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_table_149 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['Column_filter'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $shm_hitalama_map_widget_float_table_select__Filter_shm_hitalama_map_widget_float_table_150 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_hitalama_map_widget_float_table_select['Filter'] >
	>
	type $shm_hitalama_map_widget_float_table_select__value_shm_hitalama_map_widget_float_table_151 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['column_sort'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_select['value'] >
	>
	type $shm_hitalama_map_widget_float_table_select__dictionary_shm_hitalama_map_widget_float_table_152 = $mol_type_enforce<
		({ 
			'none': string,
			'asc': string,
			'desc': string,
		}) 
		,
		ReturnType< $shm_hitalama_map_widget_float_table_select['dictionary'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_table_153 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_table_154 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['Sort'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_float_table_155 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_table_156 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['column_pinned'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_157 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_158 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['column_left'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_159 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_160 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['column_right'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $shm_hitalama_map_widget_float_table_col_name__value_shm_hitalama_map_widget_float_table_161 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['col_name_draft'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_col_name['value'] >
	>
	type $shm_hitalama_map_widget_float_table_col_name__commit_shm_hitalama_map_widget_float_table_162 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['col_name_commit'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_col_name['commit'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_table_163 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_table_164 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['Col_name'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_number__Dec_shm_hitalama_map_widget_float_table_165 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Dec'] >
	>
	type $mol_number__Inc_shm_hitalama_map_widget_float_table_166 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Inc'] >
	>
	type $mol_number__value_shm_hitalama_map_widget_float_table_167 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['col_width'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__hint_shm_hitalama_map_widget_float_table_168 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_number['hint'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_table_169 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_table_170 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['Col_settings_width'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $shm_hitalama_map_widget_float_table_select__value_shm_hitalama_map_widget_float_table_171 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['col_type'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_select['value'] >
	>
	type $shm_hitalama_map_widget_float_table_select__dictionary_shm_hitalama_map_widget_float_table_172 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['col_type_options'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_select['dictionary'] >
	>
	type $shm_hitalama_map_widget_float_table_select__Filter_shm_hitalama_map_widget_float_table_173 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_hitalama_map_widget_float_table_select['Filter'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_table_174 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_table_175 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['Col_type'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $shm_hitalama_map_widget_float_table_select__value_shm_hitalama_map_widget_float_table_176 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['relation_dataset'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_select['value'] >
	>
	type $shm_hitalama_map_widget_float_table_select__dictionary_shm_hitalama_map_widget_float_table_177 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['relation_dataset_options'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_select['dictionary'] >
	>
	type $shm_hitalama_map_widget_float_table_select__Filter_shm_hitalama_map_widget_float_table_178 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_hitalama_map_widget_float_table_select['Filter'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_table_179 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_table_180 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['Relation_dataset'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_textarea__value_shm_hitalama_map_widget_float_table_181 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['select_options'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__spellcheck_shm_hitalama_map_widget_float_table_182 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_textarea['spellcheck'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_table_183 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_table_184 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['Select_options'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $shm_hitalama_map_widget_float_table_select__value_shm_hitalama_map_widget_float_table_185 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['relation_display'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_select['value'] >
	>
	type $shm_hitalama_map_widget_float_table_select__dictionary_shm_hitalama_map_widget_float_table_186 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['relation_display_options'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_select['dictionary'] >
	>
	type $shm_hitalama_map_widget_float_table_select__Filter_shm_hitalama_map_widget_float_table_187 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_hitalama_map_widget_float_table_select['Filter'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_table_188 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_table_189 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['Relation_display'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_190 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_191 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['column_editor_open'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_textarea__value_shm_hitalama_map_widget_float_table_192 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['col_custom_code'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__hint_shm_hitalama_map_widget_float_table_193 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__sidebar_showed_shm_hitalama_map_widget_float_table_194 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_textarea['sidebar_showed'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_table_195 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_table_196 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['Col_custom_code'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_197 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_198 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['col_delete_ask'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_table_199 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_major__title_shm_hitalama_map_widget_float_table_200 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_map_widget_float_table_201 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['col_delete'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_202 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_203 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['col_delete_cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_204 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_map_widget_float_table_pick__trigger_content_shm_hitalama_map_widget_float_table_205 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_map_widget_float_table_pick['trigger_content'] >
	>
	type $shm_hitalama_map_widget_float_table_pick__bubble_content_shm_hitalama_map_widget_float_table_206 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_map_widget_float_table_pick['bubble_content'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_float_table_207 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_table_208 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['delete_enabled'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_209 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_210 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_number__Dec_shm_hitalama_map_widget_float_table_211 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Dec'] >
	>
	type $mol_number__Inc_shm_hitalama_map_widget_float_table_212 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Inc'] >
	>
	type $mol_number__value_shm_hitalama_map_widget_float_table_213 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['col_width'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__hint_shm_hitalama_map_widget_float_table_214 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_number['hint'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_215 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_216 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_217 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['chart_add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_218 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_219 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['echarts_add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_220 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_221 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['tabulator_add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $shm_hitalama_map_table__controller_shm_hitalama_map_widget_float_table_222 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_self'] >
		,
		ReturnType< $shm_hitalama_map_table['controller'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_223 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_map_widget_float_table_column__table_shm_hitalama_map_widget_float_table_224 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_self'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_column['table'] >
	>
	type $shm_hitalama_map_widget_float_table_column__column_shm_hitalama_map_widget_float_table_225 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['column_editor_col'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_column['column'] >
	>
	type $shm_hitalama_map_widget_float_table_column__close_shm_hitalama_map_widget_float_table_226 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['column_editor_close'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_column['close'] >
	>
	type $shm_hitalama_map_widget_float_table_column__expanded_shm_hitalama_map_widget_float_table_227 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['column_editor_fullscreen'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_column['expanded'] >
	>
	type $mol_grid_cell__sub_shm_hitalama_map_widget_float_table_228 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_grid_cell['sub'] >
	>
	type $mol_grid_cell__style_shm_hitalama_map_widget_float_table_229 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['cell_style'] >
		,
		ReturnType< $mol_grid_cell['style'] >
	>
	type $mol_grid_cell__sub_shm_hitalama_map_widget_float_table_230 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_grid_cell['sub'] >
	>
	type $mol_grid_cell__style_shm_hitalama_map_widget_float_table_231 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['cell_style'] >
		,
		ReturnType< $mol_grid_cell['style'] >
	>
	type $mol_grid_cell__sub_shm_hitalama_map_widget_float_table_232 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_grid_cell['sub'] >
	>
	type $mol_grid_cell__style_shm_hitalama_map_widget_float_table_233 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['cell_style'] >
		,
		ReturnType< $mol_grid_cell['style'] >
	>
	type $mol_grid_cell__sub_shm_hitalama_map_widget_float_table_234 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_grid_cell['sub'] >
	>
	type $mol_grid_cell__style_shm_hitalama_map_widget_float_table_235 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['cell_style'] >
		,
		ReturnType< $mol_grid_cell['style'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_236 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_list_item_label'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_237 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['table_list_item_open'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__attr_shm_hitalama_map_widget_float_table_238 = $mol_type_enforce<
		({ 
			'selected': ReturnType< $shm_hitalama_map_widget_float_table['table_list_item_current'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_grid_cell__sub_shm_hitalama_map_widget_float_table_239 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_grid_cell['sub'] >
	>
	type $mol_grid_cell__style_shm_hitalama_map_widget_float_table_240 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['cell_style'] >
		,
		ReturnType< $mol_grid_cell['style'] >
	>
	type $mol_grid_cell__sub_shm_hitalama_map_widget_float_table_241 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_grid_cell['sub'] >
	>
	type $mol_grid_cell__style_shm_hitalama_map_widget_float_table_242 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['cell_style'] >
		,
		ReturnType< $mol_grid_cell['style'] >
	>
	type $mol_grid_cell__sub_shm_hitalama_map_widget_float_table_243 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_grid_cell['sub'] >
	>
	type $mol_grid_cell__sub_shm_hitalama_map_widget_float_table_244 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_grid_cell['sub'] >
	>
	type $mol_grid_cell__sub_shm_hitalama_map_widget_float_table_245 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_grid_cell['sub'] >
	>
	type $mol_grid_cell__sub_shm_hitalama_map_widget_float_table_246 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_grid_cell['sub'] >
	>
	type $mol_grid_cell__sub_shm_hitalama_map_widget_float_table_247 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_grid_cell['sub'] >
	>
	type $mol_grid_cell__style_shm_hitalama_map_widget_float_table_248 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['cell_style'] >
		,
		ReturnType< $mol_grid_cell['style'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_249 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_widget_float_table_250 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_251 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_table_252 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__attr_shm_hitalama_map_widget_float_table_253 = $mol_type_enforce<
		({ 
			'active': ReturnType< $shm_hitalama_map_widget_float_table['add_active'] >,
			'aria-pressed': ReturnType< $shm_hitalama_map_widget_float_table['add_active'] >,
			'aria-label': string,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $shm_hitalama_map_widget_float_table_resize__width_shm_hitalama_map_widget_float_table_254 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['col_width'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_resize['width'] >
	>
	type $shm_hitalama_map_widget_float_table_resize__style_shm_hitalama_map_widget_float_table_255 = $mol_type_enforce<
		({ 
			'right': ReturnType< $shm_hitalama_map_widget_float_table['col_resize_right'] >,
		})  & ReturnType< $shm_hitalama_map_widget_float_table_resize['style'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_resize['style'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_256 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_group__checks_shm_hitalama_map_widget_float_table_257 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['cell_checkboxes'] >
		,
		ReturnType< $mol_check_group['checks'] >
	>
	export class $shm_hitalama_map_widget_float_table extends $shm_hitalama_map_widget_float {
		fullscreen( ): boolean
		relation_stack_open( ): boolean
		Widget_title_edit( ): $mol_string_button
		edit_form_title( ): string
		Create_form( ): $shm_hitalama_map_widget_float_table_form
		Create_panel( ): $mol_view
		rows( ): Record<string, any>
		col_ids( ): readonly(any)[]
		col_head_content( id: any): readonly(any)[]
		col_head_padding( id: any): string
		col_head_width( id: any): string
		Col_head( id: any): $mol_float
		cell_content_text( id: any): ReturnType< ReturnType< $shm_hitalama_map_widget_float_table['Table'] >['cell_content_text'] >
		Cell( id: any): $mol_view
		table_row_ids( ): readonly(string[])[]
		grid_cells( id: any): readonly($mol_view)[]
		row_selected( id: any): boolean
		Grid_row( id: any): $mol_grid_row
		Table( ): $shm_hitalama_map_widget_float_table_grid
		empty_message( ): string
		Empty( ): $mol_view
		empty_content( ): readonly(any)[]
		Table_scroll( ): $mol_scroll
		search( next?: string ): string
		Search( ): $mol_search
		search_field_visible( ): readonly(any)[]
		query_status( ): string
		Query_status( ): $mol_view
		query_status_visible( ): readonly(any)[]
		reset_filters( next?: any ): any
		Reset_filters( ): $mol_button_minor
		reset_visible( ): readonly(any)[]
		Query_tools( ): $mol_view
		active_filter_text( ): string
		Active_filters( ): $mol_view
		active_filter_content( ): readonly(any)[]
		add( next?: any ): any
		Add_row_icon( ): $mol_icon_plus
		add_active( ): boolean
		Add_row( ): $mol_button_minor
		add_column( next?: any ): any
		Add_column_icon( ): $mol_icon_plus
		Add_column( ): $shm_hitalama_map_widget_float_table_command
		table_edit_toggle( next?: any ): any
		Edit_table_icon( ): $mol_icon_table_edit
		table_edit_active( ): boolean
		Edit_table( ): $mol_button_minor
		search_toggle( next?: any ): any
		Search_toggle_icon( ): $mol_icon_magnify
		search_active( ): boolean
		search_opened( ): boolean
		Search_toggle( ): $mol_button_minor
		add_tools_visible( ): readonly(any)[]
		page_index( next?: number ): number
		page_label( ): string
		Pagination_value( ): $mol_view
		Pagination( ): $mol_paginator
		page_size_selected( next?: string ): string
		Page_size( ): $mol_select
		Page_size_label( ): $mol_labeler
		Pagination_controls( ): $mol_view
		pagination_visible( ): readonly(any)[]
		Table_toolbar( ): $mol_view
		Table_panel( ): $mol_view
		Table_editor_title( ): $mol_view
		table_edit_close( next?: any ): any
		Table_editor_close( ): $mol_button_minor
		Table_editor_head( ): $mol_view
		table_schema( next?: string ): string
		table_schema_enabled( ): boolean
		Table_schema( ): $mol_textarea
		Table_schema_field( ): $mol_form_field
		table_rows_limit( next?: number ): number
		Table_rows_limit( ): $mol_number
		Table_rows_limit_field( ): $mol_form_field
		delete_enabled( next?: boolean ): boolean
		Table_delete_rows( ): $mol_check_box
		Table_widths( ): $mol_list
		Table_widths_field( ): $mol_form_field
		column_visibility_options( ): readonly(string)[]
		columns_visible( next?: readonly(string)[] ): readonly(string)[]
		Table_visibility( ): $shm_check_list
		Table_visibility_field( ): $mol_form_field
		table_editor_fields( ): readonly(any)[]
		Table_editor_content( ): $mol_list
		Table_editor( ): $mol_scroll
		Table_editor_panel( ): $mol_view
		edit_row_index( ): number
		Edit_form( ): $shm_hitalama_map_widget_float_table_form
		Edit_panel( ): $mol_view
		workspace_content( ): readonly(any)[]
		Workspace( ): $mol_view
		table_relation_page_index( id: any): number
		Table_relation_edit_form( id: any): $shm_hitalama_map_widget_float_table_relation_form
		column_editor_close( next?: any ): any
		column_editor_fullscreen( next?: boolean ): boolean
		Cell_text_scroll( id: any): $mol_view
		Copy_icon( id: any): $mol_icon_content_copy
		cell_content_text_str( id: any): string
		Cell_copy( id: any): $shm_button_copy
		Copy_area( id: any): $mol_view
		col_width_px( id: any): string
		cell_style( id: any): ({ 
			'transition': string,
			'maxWidth': ReturnType< $shm_hitalama_map_widget_float_table['col_width_px'] >,
			'width': ReturnType< $shm_hitalama_map_widget_float_table['col_width_px'] >,
		}) 
		table_atom_label( id: any): string
		table_atom_open( id: any, next?: any ): any
		table_atom_current( id: any): boolean
		Table_atom_item( id: any): $mol_button_minor
		table_atom_item_visible( id: any): readonly(any)[]
		table_atom_value( id: any, next?: string ): string
		table_relation_options( id: any): Record<string, any>
		Table_atom_pick_icon( id: any): $mol_icon_dots_vertical
		Table_atom_pick( id: any): $mol_select
		table_relation_create( id: any, next?: any ): any
		Table_atom_create_icon( id: any): $mol_icon_plus
		Table_atom_create( id: any): $mol_button_minor
		Table_atom_link_content( id: any): $mol_view
		Table_list_pick_icon( id: any): $mol_icon_dots_vertical
		table_list_option_ids( id: any): readonly(string)[]
		table_list_picker_value( id: any, next?: readonly(string)[] ): readonly(string)[]
		Table_list_options( id: any): $shm_hitalama_map_widget_float_table_link_list
		Table_list_pick( id: any): $mol_pick
		Table_list_create_icon( id: any): $mol_icon_plus
		table_relation_create_current( id: any): boolean
		Table_list_create( id: any): $mol_button_minor
		table_list_items( id: any): readonly($mol_view)[]
		Table_list_link_content( id: any): $mol_view
		table_select_value( id: any, next?: string ): string
		table_select_options( id: any): Record<string, any>
		Table_select( id: any): $mol_select
		table_list_item_label( id: any): string
		table_list_item_open( id: any, next?: any ): any
		table_list_item_current( id: any): boolean
		cell_file_uri( id: any): string
		cell_file_name( id: any): string
		Download_icon( id: any): $mol_icon_download
		Download( id: any): $mol_button_download
		cell_file_visible( id: any): readonly(any)[]
		Cell_file_scroll( id: any): $mol_view
		cell_file_pb_uri( id: any): string
		Download_pb_icon( id: any): $mol_icon_download
		cell_file_pb_name( id: any): string
		Download_pb( id: any): $mol_link
		cell_file_pb_visible( id: any): readonly(any)[]
		Cell_file_pb_scroll( id: any): $mol_view
		cell_index_number( id: any): string
		cell_checked( id: any, next?: boolean ): boolean
		Checkbox( id: any): $mol_check_box
		cell_delete( id: any, next?: any ): any
		Action_delete( id: any): $mol_button_minor
		cell_delete_visible( id: any): readonly(any)[]
		cell_edit( id: any, next?: any ): any
		action_edit_active( id: any): boolean
		Action_edit( id: any): $mol_button_minor
		custom_cell_content( id: any): readonly(any)[]
		Cell_custom_scroll( id: any): $mol_view
		Add_icon( ): $mol_icon_plus
		col_resize_right( id: any): string
		Col_head_title( id: any): $mol_view
		col_indicators( id: any): string
		col_indicators_hint( id: any): string
		Col_indicators( id: any): $mol_view
		Col_settings_icon( id: any): $mol_icon_dots_vertical
		Column_filter( id: any): $shm_hitalama_map_widget_float_table_filter
		Filter_label( id: any): $mol_labeler
		column_sort( id: any, next?: string ): string
		Sort( id: any): $shm_hitalama_map_widget_float_table_select
		Sort_label( id: any): $mol_labeler
		column_pinned( id: any, next?: boolean ): boolean
		Pin( id: any): $mol_check_box
		column_left( id: any, next?: any ): any
		Move_left( id: any): $mol_button_minor
		column_right( id: any, next?: any ): any
		Move_right( id: any): $mol_button_minor
		col_name_draft( id: any, next?: string ): string
		col_name_commit( id: any, next?: any ): any
		Col_name( id: any): $shm_hitalama_map_widget_float_table_col_name
		Col_name_label( id: any): $mol_labeler
		col_width( id: any, next?: number ): number
		Col_settings_width( id: any): $mol_number
		Col_width_label( id: any): $mol_labeler
		col_type( id: any, next?: string ): string
		col_type_options( ): Record<string, any>
		Col_type( id: any): $shm_hitalama_map_widget_float_table_select
		Col_type_label( id: any): $mol_labeler
		relation_dataset( id: any, next?: string ): string
		relation_dataset_options( ): Record<string, any>
		Relation_dataset( id: any): $shm_hitalama_map_widget_float_table_select
		Relation_dataset_label( id: any): $mol_labeler
		relation_dataset_visible( id: any): readonly(any)[]
		select_options( id: any, next?: string ): string
		Select_options( id: any): $mol_textarea
		Select_options_label( id: any): $mol_labeler
		select_options_visible( id: any): readonly(any)[]
		relation_display( id: any, next?: string ): string
		relation_display_options( id: any): Record<string, any>
		Relation_display( id: any): $shm_hitalama_map_widget_float_table_select
		Relation_display_label( id: any): $mol_labeler
		relation_display_visible( id: any): readonly(any)[]
		column_editor_open( id: any, next?: any ): any
		Col_code_open( id: any): $mol_button_minor
		col_custom_code( id: any, next?: string ): string
		Col_custom_code( id: any): $mol_textarea
		Col_custom_code_label( id: any): $mol_labeler
		col_custom_code_help( id: any): string
		Col_custom_code_help( id: any): $mol_view
		custom_code_visible( id: any): readonly(any)[]
		col_delete_ask( id: any, next?: any ): any
		Delete_column_icon( id: any): $mol_icon_trash_can_outline
		Delete_column( id: any): $mol_button_minor
		col_delete( id: any, next?: any ): any
		Delete_column_confirm( id: any): $mol_button_major
		col_delete_cancel( id: any, next?: any ): any
		Delete_column_cancel( id: any): $mol_button_minor
		col_delete_confirm_visible( id: any): readonly(any)[]
		Col_settings_bubble( id: any): $mol_view
		Col_settings( id: any): $shm_hitalama_map_widget_float_table_pick
		cell_checkboxes( ): readonly(any)[]
		Deleting( ): $mol_check_box
		deleting_tool_visible( ): readonly(any)[]
		Col_widths_head( ): $mol_view
		Col_width_title( id: any): $mol_view
		Col_width( id: any): $mol_number
		Col_width_row( id: any): $mol_view
		col_width_rows( ): readonly(any)[]
		chart_add( next?: any ): any
		Chart_add( ): $mol_button_minor
		echarts_add( next?: any ): any
		Echarts_add( ): $mol_button_minor
		tabulator_add( next?: any ): any
		Tabulator_add( ): $mol_button_minor
		table_scroll_top( next?: number ): number
		table_viewport_height( ): number
		table_header_height( ): number
		table_virtual( ): boolean
		attr( ): ({ 
			'shm_hitalama_map_widget_float_table_fullscreen': ReturnType< $shm_hitalama_map_widget_float_table['fullscreen'] >,
			'relation_open': ReturnType< $shm_hitalama_map_widget_float_table['relation_stack_open'] >,
		})  & ReturnType< $shm_hitalama_map_widget_float['attr'] >
		head( ): readonly(any)[]
		Table_content( ): $shm_hitalama_map_table
		controls( ): readonly(any)[]
		Table_relation_edit_panel( id: any): $mol_view
		Column_editor( ): $shm_hitalama_map_widget_float_table_column
		column_editor_col( next?: number ): number
		table_list_cell_id( id: any): any
		col_settings_title( id: any): string
		table_self( ): any
		Cell_text( id: any): $mol_grid_cell
		Cell_table_atom_link( id: any): $mol_grid_cell
		Cell_table_list_link( id: any): $mol_grid_cell
		Cell_table_select( id: any): $mol_grid_cell
		Table_list_item( id: any): $mol_button_minor
		Cell_file( id: any): $mol_grid_cell
		Cell_file_pb( id: any): $mol_grid_cell
		Cell_index_number( id: any): $mol_grid_cell
		Cell_checkbox( id: any): $mol_grid_cell
		Cell_delete( id: any): $mol_grid_cell
		Cell_edit( id: any): $mol_grid_cell
		Cell_custom( id: any): $mol_grid_cell
		Add( ): $mol_button_minor
		Col_resize( id: any): $shm_hitalama_map_widget_float_table_resize
		Col_head_content( id: any): $mol_view
		All_check( ): $mol_check_group
		checkboxes_showed( ): boolean
		tools_custom( ): readonly(any)[]
		settings_content( ): readonly(any)[]
		contextmenu_body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=table.view.tree.d.ts.map